export default "__VITE_ASSET__7b7d9b10__"